export const SIZE_PRESETS = {
  sm: { height: 36, fontSize: 13, borderRadius: 8, logoSize: 24 },
  md: { height: 44, fontSize: 16, borderRadius: 10, logoSize: 32 },
  lg: { height: 52, fontSize: 18, borderRadius: 12, logoSize: 36 },
} as const;

export const DEFAULT_COLORS = {
  button: "#007145",
  buttonText: "#FFFFFF",
  logo: "#5A5A5A",
  logoIcon: "#FFFFFF",
  label: "#5A5A5A",
} as const;

export const DEFAULTS = {
  text: "Start Your Free Estimate",
  label: "Get Faster Quotes With Video:",
  size: "md" as const,
  width: "auto" as const,
  glass: false,
  inputBorder: "none",
  buttonBorder: "none",
  variant: "default" as const,
  locale: "en-US",
  platform: "embed-button",
};
